var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHighFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6875 27.5753C57.8312 25.7346 59.3704 24.2856 61.248 24.2856C63.2204 24.2856 64.8194 25.8846 64.8194 27.8571L64.8197 28.1368C65.4613 27.5212 66.3325 27.1428 67.292 27.1428C69.2644 27.1428 70.8634 28.7418 70.8634 30.7142C70.8634 36.1969 71.0582 41.6511 71.631 46.8942C71.9561 45.7684 72.2844 44.653 72.608 43.5536L72.7942 42.9207C73.3508 41.0284 75.336 39.9455 77.2283 40.5021C79.1206 41.0586 80.2034 43.0438 79.6468 44.9361L79.5323 45.3257C77.7623 51.3423 76.0523 57.1548 75.3263 62.5079C75.2855 62.8083 75.2482 63.1055 75.2142 63.3994C77.2133 68.924 80.0732 73.8359 84.1233 77.807C85.4826 79.1398 85.5507 81.2925 84.3123 82.7072C83.7947 83.6011 82.8953 84.2644 81.7963 84.4439C72.6187 85.9432 64.5253 82.4383 60.1844 78.2988C53.9894 72.3912 50.1758 65.8745 48.283 58.3806C46.41 50.965 46.4681 42.7903 47.6799 33.6164C47.9382 31.661 49.7328 30.2851 51.6882 30.5434C51.9395 30.5766 52.1811 30.6352 52.411 30.7162V30.7142C52.411 28.7418 54.01 27.1428 55.9824 27.1428C56.5999 27.1428 57.1808 27.2995 57.6875 27.5753Z",
    fill: "#E283B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9584 55.3573C68.9584 55.3573 68.9584 52.5001 71.4584 46.4287",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4763 48.0361C58.4763 48.0361 58.0834 36.6286 57.5703 30.0357C57.4527 28.5247 57.892 27.0183 58.8425 25.8379L58.9419 25.7145",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8823 27.2372C66.1863 27.4886 66.2289 27.9388 65.9774 28.2428C65.2745 29.0926 64.9353 30.1901 65.0105 31.3065C65.2317 34.5891 65.405 39.1897 65.5229 42.9623C65.5819 44.8502 65.6271 46.5335 65.6576 47.7449C65.6729 48.3506 65.6844 48.8383 65.6922 49.1748L65.7038 49.6961C65.7039 49.6962 65.7039 49.6967 64.9897 49.7119C64.2756 49.7271 64.2756 49.727 64.2756 49.7269L64.264 49.2077C64.2562 48.8721 64.2447 48.3854 64.2295 47.7808C64.1991 46.5716 64.1539 44.8913 64.095 43.007C63.9771 39.2352 63.8044 34.6571 63.5851 31.4025C63.4864 29.9376 63.9306 28.476 64.8767 27.3323C65.1281 27.0283 65.5783 26.9857 65.8823 27.2372ZM65.0049 50.426C64.6105 50.4344 64.284 50.1213 64.2756 49.7269L64.9897 49.7119L65.7038 49.6961C65.7122 50.0905 65.3993 50.4176 65.0049 50.426Z",
    fill: "#002E52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8386 46.8683C52.8386 46.8683 52.475 38.8186 51.9636 32.9741C51.8227 31.3633 52.2837 29.7526 53.2925 28.4889V28.4889",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5629 26.1466C43.4192 24.3059 41.88 22.8569 40.0024 22.8569C38.0299 22.8569 36.4309 24.4559 36.4309 26.4284L36.4307 26.7081C35.789 26.0925 34.9179 25.7141 33.9584 25.7141C31.986 25.7141 30.387 27.3131 30.387 29.2855C30.387 34.7682 30.1922 40.2224 29.6193 45.4655C29.2943 44.3397 28.966 43.2243 28.6424 42.1249L28.4561 41.4919C27.8996 39.5996 25.9144 38.5168 24.0221 39.0734C22.1298 39.6299 21.047 41.6151 21.6035 43.5074L21.7181 43.897C23.4881 49.9136 25.1981 55.7261 25.9241 61.0792C25.9649 61.3796 26.0022 61.6768 26.0361 61.9706C24.037 67.4953 21.1771 72.4072 17.1271 76.3782C15.7678 77.711 15.6996 79.8638 16.9381 81.2784C17.4557 82.1724 18.355 82.8357 19.454 83.0152C28.6317 84.5145 36.7251 81.0096 41.066 76.8701C47.2609 70.9625 51.0746 64.4458 52.9674 56.9518C54.8404 49.5363 54.7823 41.3616 53.5705 32.1877C53.3122 30.2322 51.5176 28.8564 49.5621 29.1147C49.3109 29.1479 49.0692 29.2065 48.8394 29.2875V29.2855C48.8394 27.3131 47.2404 25.7141 45.2679 25.7141C44.6504 25.7141 44.0695 25.8708 43.5629 26.1466Z",
    fill: "#F0C1D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6013 54.9998C28.6013 54.9998 29.3156 51.0712 29.3156 45.3569",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4585 47.1429C41.4585 47.1429 42.289 36.3459 42.4876 29.8641C42.5341 28.3493 43.132 26.898 44.2036 25.8264L44.3156 25.7144",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7441 47.1427C35.7441 47.1427 36.6114 33.8455 36.7854 27.0161C36.8183 25.7229 37.3294 24.486 38.2441 23.5713V23.5713",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1727 47.4999C47.1727 47.4999 47.7087 39.4599 47.8521 33.5948C47.8916 31.9783 48.5294 30.429 49.6727 29.2856V29.2856",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80.387,
    y1: 21.1329,
    x2: 84.3768,
    y2: 17.1431,
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 85.6569,
    y1: 30.3659,
    x2: 90.5679,
    y2: 27.5874,
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.714286,
    y1: -0.714286,
    x2: 6.35678,
    y2: -0.714286,
    transform: "matrix(0.870356 0.492424 0.492424 -0.870356 83.9584 51.4287)",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 87.536,
    y1: 41.435,
    x2: 93.1783,
    y2: 41.4843,
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.714286,
    y1: -0.714286,
    x2: 6.35678,
    y2: -0.714286,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 18.8864 22.1431)",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.714286,
    y1: -0.714286,
    x2: 6.35678,
    y2: -0.714286,
    transform: "matrix(-0.870356 -0.492424 -0.492424 0.870356 13.8864 31.3394)",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 15.045,
    y1: 52.4021,
    x2: 10.134,
    y2: 55.1806,
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.714286,
    y1: -0.714286,
    x2: 6.35678,
    y2: -0.714286,
    transform: "matrix(-0.999962 0.00872654 0.00872654 0.999962 12.4578 42.1431)",
    stroke: "#002E52",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighFive);
export default __webpack_public_path__ + "static/media/icon_high_five.b39f3e8e045087c0fb76345f2bf540a7.svg";
export { ForwardRef as ReactComponent };